import { useRef, useState } from 'react';
import { PromptGroup } from '@server/prompts';
import { Stack } from '@mui/material';
import { PromptCard } from './promptGroupCard/PromptCard';
import { PromptsLibraryDialog } from './PromptsLibraryDialog';
import { PromptGroupMinimizedPopover } from './PromptGroupMinimizedPopover';
import { selectPromptGroups } from '../../../reducers/promptLibraryReducer';
import { useSelector } from 'react-redux';

interface PromptGroupsMinimizedProps {
  onPromptClick: (promptTitle: string) => Promise<void>;
}

export const PromptGroupsMinimized = ({ onPromptClick }: PromptGroupsMinimizedProps) => {
  const allPromptGroups = useSelector(selectPromptGroups);
  const [openPromptsLibraryDialog, setOpenPromptsLibraryDialog] = useState(false);
  const [selectedGroup, setSelectedGroup] = useState<PromptGroup | null>(null);
  const parentRef = useRef<HTMLDivElement>(null);
  const minimizedPromptGroups =
    allPromptGroups?.filter((promptGroup) => promptGroup.isPinned) ?? [];

  return (
    <>
      {openPromptsLibraryDialog && (
        <PromptsLibraryDialog
          open={openPromptsLibraryDialog}
          onClose={() => setOpenPromptsLibraryDialog(false)}
          onPromptClick={onPromptClick}
        />
      )}

      {selectedGroup && (
        <PromptGroupMinimizedPopover
          prompt={selectedGroup}
          onClose={() => setSelectedGroup(null)}
          onPromptClick={onPromptClick}
          anchorEl={parentRef.current}
        />
      )}

      <Stack
        direction="row"
        gap={1}
        flexWrap="wrap"
        justifyContent="center"
        alignItems="center"
        ref={parentRef}
      >
        {minimizedPromptGroups.map((prompt) => (
          <PromptCard
            key={prompt.id}
            promptGroup={prompt}
            onClick={() => {
              setSelectedGroup(prompt);
            }}
            isMinimized={true}
          />
        ))}

        {/* by product definition: always show 'more' to allow access to library */}
        <PromptCard
          key="more"
          promptGroup={{
            id: 'more',
            name: 'More',
            description: '',
            iconName: 'Plus',
            prompts: [],
            isPinned: true,
            accountId: '',
            createdAt: '',
            updatedAt: '',
          }}
          onClick={() => setOpenPromptsLibraryDialog(true)}
          isMinimized={true}
        />
      </Stack>
    </>
  );
};
